module.exports = __webpack_public_path__ + "img/2.77e848c9.png";